// src/components/Modal.jsx — modale de confirmation générique.
// Pattern : titre + message + bouton OK (rouge par défaut) + bouton Annuler.
// Pour des modales typées (formulaires d'édition, etc.), créer un composant
// dédié dans src/modals/ ; ce fichier reste minimal pour les confirmations.

import { DS } from '../lib/ui'

// Props additives (chantier « L'avoir a un bouton ») :
//   - children   : contenu libre entre le message et les boutons (ex. une case
//                  de confirmation, une liste de faits). Absent = rendu inchangé.
//   - okDisabled : grise le bouton OK tant qu'une condition n'est pas remplie
//                  (ex. case non cochée). Défaut false = comportement inchangé.
export const Modal = ({ title, msg, onOk, onCancel, okLabel = "Confirmer", okColor = "#c0392b", children = null, okDisabled = false }) => (
  <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.55)",zIndex:999,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
    <div style={{background:DS.white,borderRadius:16,padding:24,maxWidth:320,width:"100%",maxHeight:"90vh",overflowY:"auto",boxShadow:"0 16px 48px rgba(0,0,0,.22)",fontFamily:DS.fontBody}}>
      <div style={{fontFamily:DS.fontDisplay,fontWeight:700,fontSize:17,color:DS.navy,marginBottom:10}}>{title}</div>
      <p style={{fontSize:13,color:"#555",margin:children?"0 0 12px":"0 0 20px",lineHeight:1.6,fontFamily:DS.fontBody}}>{msg}</p>
      {children && <div style={{margin:"0 0 20px"}}>{children}</div>}
      <div style={{display:"flex",gap:8}}>
        <button onClick={onCancel} style={{flex:1,minHeight:44,padding:11,background:"#f2f5f9",color:"#555",border:"none",borderRadius:8,fontWeight:600,cursor:"pointer",fontFamily:DS.fontBody}}>Annuler</button>
        <button onClick={okDisabled ? undefined : onOk} disabled={okDisabled} aria-disabled={okDisabled}
          style={{flex:1,minHeight:44,padding:11,background:okDisabled?"#cfd6de":okColor,color:"#fff",border:"none",borderRadius:8,fontWeight:700,cursor:okDisabled?"not-allowed":"pointer",fontFamily:DS.fontBody}}>{okLabel}</button>
      </div>
    </div>
  </div>
)

export default Modal
